import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { retryWhen, scan, tap, delay } from "rxjs/operators";
import {
  CertificateDisplayInfo,
  CertificateService,
} from "src/app/services/certificate.service";

@Component({
  selector: "app-certificate-issue",
  templateUrl: "./certificate-issue.component.html",
  styleUrls: ["./certificate-issue.component.css"],
})
export class CertificateIssueComponent implements OnInit {
  clicked = false;
  certInfo$: Observable<CertificateDisplayInfo>;
  certPass$: Observable<{ key: string }>;

  constructor(private svc: CertificateService, private router: Router) {}

  ngOnInit(): void {
    this.certInfo$ = this.svc.getCertificateDisplayInfo().pipe(
      tap((x) => {
        if (!x) {
          this.router.navigateByUrl("/admin");
        }
      })
    );
  }

  getCert() {
    if (this.clicked) {
      return;
    }

    this.clicked = true;

    setTimeout(
      () =>
        (this.certPass$ = this.svc.getCertPass().pipe(
          retryWhen((errors) =>
            errors.pipe(
              scan((acc, error) => ({ count: acc.count + 1, error }), {
                count: 0,
                error: undefined as any,
              }),
              tap((current) => {
                if (current.count > 10) {
                  throw current.error;
                }
              }),
              delay(2000)
            )
          )
        )),
      5000
    );
  }

  copy(text: string) {
    navigator.clipboard.writeText(text);
  }
}
